// extracted by mini-css-extract-plugin
export default {"container":"PageSelector_container__4o9bQ","tile":"PageSelector_tile__NPwQU","activeTile":"PageSelector_activeTile__qE8cb","arrow":"PageSelector_arrow__SgnO4"};